<file-manager [initialPath]="initialPath" [featureKey]="'SALES_FILE_MANAGER'"></file-manager>

